var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClipboardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6447 9.13291C13.9702 9.45835 13.9702 9.98599 13.6447 10.3114L9.75584 14.2003C9.4304 14.5257 8.90277 14.5257 8.57733 14.2003L6.63288 12.2559C6.30745 11.9304 6.30745 11.4028 6.63288 11.0774C6.95832 10.7519 7.48596 10.7519 7.8114 11.0774L9.16658 12.4325L12.4662 9.13291C12.7917 8.80748 13.3193 8.80748 13.6447 9.13291Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12822 4.16661C6.26492 3.07041 7.20002 2.22217 8.33325 2.22217H11.6666C12.8076 2.22217 13.7477 3.0821 13.8743 4.18922C13.8735 4.18167 13.8726 4.17414 13.8716 4.16661H14.1666C15.5473 4.16661 16.6666 5.2859 16.6666 6.66661V15.2777C16.6666 16.6584 15.5473 17.7777 14.1666 17.7777H5.83325C4.45254 17.7777 3.33325 16.6584 3.33325 15.2777V6.66661C3.33325 5.2859 4.45254 4.16661 5.83325 4.16661H6.12822ZM8.33325 3.88883H11.6666C11.9734 3.88883 12.2221 4.13757 12.2221 4.44439V5.5555C12.2221 5.86233 11.9734 6.11106 11.6666 6.11106H8.33325C8.02643 6.11106 7.7777 5.86233 7.7777 5.5555V4.44439C7.7777 4.13757 8.02643 3.88883 8.33325 3.88883ZM6.12552 5.81067C6.12638 5.81822 6.12728 5.82576 6.12822 5.83328H5.83325C5.37301 5.83328 4.99992 6.20637 4.99992 6.66661V15.2777C4.99992 15.738 5.37301 16.1111 5.83325 16.1111H14.1666C14.6268 16.1111 14.9999 15.738 14.9999 15.2777V6.66661C14.9999 6.20637 14.6268 5.83328 14.1666 5.83328H13.8716C13.7349 6.92948 12.7998 7.77772 11.6666 7.77772H8.33325C7.19225 7.77772 6.25209 6.91779 6.12552 5.81067Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardCheck);
export default __webpack_public_path__ + "static/media/iconClipboardCheck.41a7931b251ca6c6ad73d797544066d5.svg";
export { ForwardRef as ReactComponent };